/* unplugin-vue-components disabled */import { render } from "./Header.vue?vue&type=template&id=60bf4666"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=60bf4666&lang=scss"

import exportComponent from "E:\\普通网页项目\\奇力士官网新版\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__